import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {},
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 1,
  },
});
